var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.adaptive.isDesktop
    ? _c("div", { class: _vm.$options.name }, [
        _vm.showBack
          ? _c(
              "div",
              { staticClass: "icon", on: { click: _vm.back } },
              [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconBack.id }
                })
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "title" }, [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
        ]),
        _c(
          "div",
          {
            staticClass: "icon",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$f.hideNav()
              }
            }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconClose.id }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }